import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Exchange } from '../../models/exchange.model';
import { StoreDetail } from '../../models/store-details.model';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleTagManagerService } from '../../services/google-tag-manager.service';
import { isPlatformBrowser } from '@angular/common';
import { Url_Friendly_String } from '../../helpers/helper';

enum TargetSource {
  CategoryComponent = 'category',
  HomeComponent = 'home',
}

@Component({
  selector: 'shared-product-list-item',
  templateUrl: './shared-product-list-item.component.html',
  styleUrls: ['./shared-product-list-item.component.scss'],
})
export class SharedProductListItemComponent implements OnInit {
  @Input() product;
  @Input() homeIndexData?: {
    moduleIndex: number;
    itemIndex: number;
  };
  exchangeRates: Exchange[];
  storeDetail: StoreDetail;
  priceLabel: string;
  title: any;
  productPrice;
  platformId: Object;
  constructor(
    private router: Router,
    private googleTagManagerService: GoogleTagManagerService,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.platformId = platformId;
  }

  ngOnInit(): void {
    this.findMinMax();
  }

  buyProduct(productId: number, productName) {
    this.router.navigate([
      `/product/${productId}/${Url_Friendly_String(productName)}`,
    ]);
  }

  findMinMax() {
    let priceSet = [];
    if (!this.product.varieties) {
      return;
    }

    if (this.product.varieties.length == 1) {
      this.productPrice = {
        min_price: this.product?.varieties[0]?.variety_detail?.min_price,
        max_price: this.product?.varieties[0]?.variety_detail?.max_price,
      };
    } else {
      this.product.varieties.forEach((variety) => {
        priceSet.push(variety?.variety_detail?.min_price);
        priceSet.push(variety?.variety_detail?.max_price);
      });
      this.productPrice = {
        min_price: Math.min(...priceSet),
        max_price: Math.max(...priceSet),
      };
    }

    const currencySymbol = this.product.currency.symbol;
    this.priceLabel = `${currencySymbol}${Number(this.productPrice.min_price)}`;
    if (this.productPrice.min_price !== this.productPrice.max_price) {
      this.priceLabel += ` - ${currencySymbol}${Number(this.productPrice.max_price)}`;
    }
    this.title = Url_Friendly_String(this.product?.name);
  }

  onProduct() {
    let analyticData = {
      currency: this.product?.currency?.symbol,
      value: this.product.id,
      id: this.product.id,
      name: this.product?.name,
      discount_percent: this.product?.discount,
      cashback_percent: this.product?.cashback,
      source: this.targetSource,
      ...this.productPrice,
    };

    this.googleTagManagerService.sendAnalytics('view_product', {
      ...analyticData,
    });

    if (
      this.pathIsHome(this.activatedRoute.snapshot.routeConfig.component.name)
    ) {
      this.googleTagManagerService.sendAnalytics('on_home_item_click', {
        row: this.homeIndexData.moduleIndex,
        index: this.homeIndexData.itemIndex,
        item_id: this.product.id,
        item_name: this.product.name,
        currency: this.product.currency.symbol,
      });
    }
  }

  private get targetSource(): string {
    let source =
      TargetSource[this.activatedRoute.snapshot.routeConfig.component.name];
    if (!source && this.product.isRelatedTarget) {
      source = 'related';
    }
    return source;
  }

  private pathIsHome(name: string) {
    return name === 'HomeComponent';
  }

  isClientPlatform(platformId: Object): boolean {
    return isPlatformBrowser(platformId);
  }
}
